import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../../../auth/auth.service';
import { resolveEventFormOrganizationId } from './event-form-org.util';
import {
  cateringFieldEnabledOrgKey,
  EVENT_CATERING_FIELD_EVENT_TYPES,
} from './event-catering-field.util';

function isOrgSettingTrue(value: unknown): boolean {
  return value === true || value === 'true' || value === 1 || value === '1';
}

/**
 * Whether the forplejning field is shown for the selected event_type (org setting per type, default on).
 */
export function event_catering_field_visible(
  service: ComponentDataSourceService
): DataSourceFunction {
  return {
    name: 'event_catering_field_visible',
    description:
      'Whether catering dropdown is shown for the current event type (events_catering_field_*_enabled org settings).',
    execute: (params?: LoadDataParams): Observable<{ visible: boolean }> => {
      const auth = service.injector.get(AuthService);
      const orgId = resolveEventFormOrganizationId(params, auth);
      const query = params?.queryParams ?? {};
      const eventType = String(query['event_type'] ?? '').trim();

      if (!eventType) {
        return of({ visible: true });
      }

      if (
        !EVENT_CATERING_FIELD_EVENT_TYPES.includes(
          eventType as (typeof EVENT_CATERING_FIELD_EVENT_TYPES)[number]
        )
      ) {
        return of({ visible: true });
      }

      if (orgId == null) {
        return of({ visible: true });
      }

      const obs = service.executeDataSource('org_settings', { organizationId: orgId });
      if (!obs) {
        return of({ visible: true });
      }

      return obs.pipe(
        map((res: { data?: Record<string, unknown> }) => {
          const key = cateringFieldEnabledOrgKey(eventType);
          const raw = res?.data?.[key];
          if (raw === undefined || raw === null) {
            return { visible: true };
          }
          return { visible: isOrgSettingTrue(raw) };
        }),
        catchError(() => of({ visible: true }))
      );
    },
  };
}
